module.exports = __webpack_public_path__ + "static/media/vf_wbag_core.57dbeb44.svg";